import * as React from "react";
import { CopyButtonWithApproval } from "../../../pages/domain/create/copyButtonWithApproval";
import { LinkOutlined } from "@ant-design/icons";

export interface ExternalLinkProps {
  url: string;
  label: string;
  disableCopy?: boolean;
  className?: string;
}
export const ExternalLink: React.FC<ExternalLinkProps> = ({ url, label, className = "", disableCopy = false }) => {
  return (
    <div className={`inline items-center ${className}`}>
      <a className="truncate color-link" href={url} target={"_blank"}>
        <span>{label}</span>
        <LinkOutlined className={`inline-block ml-1`} size={16} />
      </a>
      {disableCopy ? null : <CopyButtonWithApproval className="ml-1" value={url} />}
    </div>
  );
};
